<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('domain.nameservers.title') }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    <div v-if="nameservers.length" dusk="nameservers">
                        <div v-for="nameserver in nameservers" :key="nameserver.name">
                            {{ nameserver.name }}
                        </div>
                    </div>
                    <div v-else>
                        {{ trans('domain.nameservers.none') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav | u-align-self-start">
            <customer-router-link :to="{ name: 'nameserverOverview' }">
                <button type="button" class="btn btn--ghost btn--ghost-full-width">
                    {{ trans('domain.nameservers.edit') }}
                </button>
            </customer-router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        nameservers: {
            type: Array,
            default: null
        },
        nameservergroup: {
            type: String,
            default: null
        },
        domain: {
            type: String,
            required: true
        }
    }
};
</script>
